// request
export interface DashboardKPIRequest {
  SubCompanyList: string;
  PolicyTypeList: string;
  AgentContactId: null;
  AgencyContactId: number;
  YTD: boolean;
  MonthsToInclude: any;
  FrmDt?: Date;
  ToDt?: Date;
}

// response
export interface DashboardKPIResponse {
  SubmissionCount: number;
  QuotedCount: number;
  BoundCount: number;
  ConversionRatio: number;
  CommissionsPaid: number;
  ClaimsIncurred: number;
  GrossWrittenPremium: number;
}
